export const vserver = {
  title: 'VServer',
  subtitle: 'Verwalte deine virtuellen Server',
  noSubscription: {
    title: 'Noch kein VServer aktiv',
    description: 'Erstelle deinen ersten VServer mit wenigen Klicks.',
    action: 'VServer bestellen'
  },
  selector: {
    none: 'Kein VServer ausgewählt',
    label: 'Aktiver VServer'
  },
  tabs: {
    overview: 'Übersicht',
    console: 'Konsole',
    network: 'Netzwerk',
    snapshots: 'Snapshots',
    graphs: 'Auslastung',
    settings: 'Einstellungen'
  },
  status: {
    provisioning: 'Wird bereitgestellt',
    active: 'Aktiv',
    stopped: 'Gestoppt',
    failed: 'Fehlgeschlagen',
    resizing: 'Wird angepasst',
    reinstalling: 'Wird neu installiert',
    suspended: 'Beendet',
    deprovisioning: 'Wird gelöscht',
    deprovisioned: 'Gelöscht'
  },
  overview: {
    sectionTitle: 'Server-Informationen',
    hostname: 'Hostname',
    status: 'Status',
    ipv4: 'IPv4-Adresse',
    ipv6: 'IPv6-Prefix',
    mac: 'MAC-Adresse',
    os: 'Betriebssystem',
    plan: 'Tarif',
    vcpu: 'vCPU',
    memory: 'Arbeitsspeicher',
    disk: 'Festplatte',
    uptime: 'Laufzeit',
    guestAgent: 'Gast-Agent',
    guestAgentRunning: 'Aktiv',
    guestAgentStopped: 'Nicht erkannt',
    guestAgentHint: 'Der Gast-Agent reagiert nicht. Funktionen wie Passwort-Reset und SSH-Schlüssel-Einspielung benötigen einen laufenden Agent.',
    keylessTitle: 'Noch kein Zugang eingerichtet',
    keylessMessage: 'Dein Server läuft, hat aber noch keinen SSH-Schlüssel. Spiele jetzt einen Schlüssel ein — oder setze unter Einstellungen ein Root-Passwort für die Web-Konsole.',
    keylessAction: 'SSH-Schlüssel einspielen',
    failedTitle: 'Vorgang fehlgeschlagen',
    failedProvisioning: 'Die Einrichtung deines Servers ist fehlgeschlagen. Wir versuchen es automatisch erneut. Klappt das nicht, erstatten wir dir den Betrag und schreiben dir eine E-Mail.',
    failedOperation: 'Der letzte Vorgang auf deinem Server ist fehlgeschlagen. Melde dich beim Support, falls der Server nicht wieder läuft.',
    suspendedTitle: 'Abonnement beendet, Server gestoppt',
    suspendedBody: 'Das Abonnement dieses Servers ist beendet, deshalb wurde er gestoppt. Bis einschließlich {date} bleibt er mit seiner Festplatte, seinen Snapshots und seiner IP-Adresse erhalten, danach wird er gelöscht. Wenn du ihn behalten möchtest, melde dich vorher bei unserem Support.',
    suspendedBodyUndated: 'Das Abonnement dieses Servers ist beendet, deshalb wurde er gestoppt. 30 Tage lang bleibt er mit seiner Festplatte, seinen Snapshots und seiner IP-Adresse erhalten, danach wird er gelöscht. Wenn du ihn behalten möchtest, melde dich vorher bei unserem Support.',
    createdAt: 'Erstellt am',
    provisionedAt: 'Bereitgestellt am',
    powerControls: 'Steuerung',
    start: 'Starten',
    stop: 'Stoppen',
    restart: 'Neu starten',
    confirmStop: 'VServer wirklich stoppen?',
    confirmRestart: 'VServer wirklich neu starten?'
  },
  console: {
    title: 'Web-Konsole',
    subtitle: 'Greife per Web-Konsole direkt auf deinen VServer zu.',
    connect: 'Verbinden',
    disconnect: 'Trennen',
    fullscreen: 'Vollbild',
    sendCtrlAltDel: 'Strg+Alt+Entf senden',
    pasteClipboard: 'Aus Zwischenablage einfügen',
    connecting: 'Verbindung wird aufgebaut...',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    notRunning: 'Der VServer muss laufen, um die Konsole zu öffnen.',
    locked: 'Die Konsole ist nicht verfügbar, solange der Server gesperrt ist.',
    error: 'Konsolen-Verbindung fehlgeschlagen'
  },
  identityUnproven: {
    title: 'Steuerung gesperrt',
    body: 'Wir konnten nicht bestätigen, dass die virtuelle Maschine hinter diesem Server zu ihm gehört. Zu deinem Schutz sind Starten, Stoppen, die Konsole und die übrigen Aktionen gesperrt, bis unser Support das geklärt hat. Bitte melde dich beim Support.'
  },
  locked: {
    title: 'Server gesperrt',
    body: 'Wir haben diesen Server gesperrt und gestoppt. Du kannst ihn nicht starten, neu installieren oder auf einen Snapshot zurücksetzen. Festplatte, Snapshots und IP-Adressen bleiben erhalten, und löschen kannst du ihn weiterhin.',
    note: 'Begründung: {note}',
    contact: 'Wenn du den Verstoß behoben hast oder widersprechen möchtest, melde dich bei unserem Support.'
  },
  paymentDue: {
    title: 'Zahlung für deinen Tarifwechsel offen',
    body: 'Die Zahlung für den Wechsel deines Servers in den höheren Tarif ist fehlgeschlagen. Der Server läuft bereits im neuen Tarif. Bezahle den Unterschied von {amount} bis zum {date} oder stelle den Server in den bisherigen Tarif zurück. Tust du keines von beiden, endet der Vertrag mit Ablauf dieser Frist.',
    bodyUnpriced: 'Die Zahlung für den Wechsel deines Servers in den höheren Tarif ist fehlgeschlagen. Der Server läuft bereits im neuen Tarif. Bezahle den Unterschied bis zum {date} oder stelle den Server in den bisherigen Tarif zurück. Tust du keines von beiden, endet der Vertrag mit Ablauf dieser Frist.',
    pay: 'Unterschied bezahlen',
    switchBack: 'In den bisherigen Tarif zurückstellen'
  },
  smtp: {
    title: 'Ausgehender Port 25',
    submissionHint: 'Mails über die Submission-Ports 587 und 465 an deinen Mailanbieter gehen jederzeit.',
    opensAt: 'Die Sperre endet automatisch am {date}.',
    pendingShort: 'Wir prüfen deine Anfrage und melden uns per E-Mail.',
    status: {
      open: 'Ausgehender Port 25 (Zustellung an fremde Mailserver) ist für deine VServer offen.',
      blocked: 'In den ersten drei Monaten nach deiner ersten VServer-Bestellung ist ausgehender Port 25 (Zustellung an fremde Mailserver) für alle deine VServer gesperrt, um Spam von frischen Servern zu verhindern.',
      pending: 'Du hast die Freigabe am {date} beantragt. Wir prüfen die Anfrage und melden uns per E-Mail.',
      denied: 'Deine Anfrage wurde abgelehnt. An der automatischen Freigabe ändert das nichts.',
      deniedReason: 'Begründung: {reason}',
      cooldown: 'Eine neue Anfrage kannst du ab dem {date} stellen.',
      forced: 'Wir haben ausgehenden Port 25 für alle deine VServer gesperrt, weil es Hinweise auf Spam-Versand von ihnen gibt. Die Begründung haben wir dir per E-Mail geschickt. Wenn du widersprechen möchtest, melde dich bei unserem Support.'
    },
    request: {
      button: 'Freigabe beantragen',
      dialogTitle: 'Port 25 vorzeitig freigeben',
      dialogDescription: 'Beschreib kurz, wofür du Port 25 brauchst, etwa einen eigenen Mailserver für deine Domains. Wir prüfen die Anfrage von Hand und melden uns per E-Mail.',
      reasonLabel: 'Verwendungszweck',
      reasonPlaceholder: 'z. B. eigener Mailserver für meine Domain',
      submit: 'Anfrage senden',
      success: 'Anfrage gesendet',
      error: 'Anfrage nicht gesendet'
    },
    errors: {
      notBlocked: 'Port 25 ist für deine VServer schon offen.',
      noVServer: 'Eine Freigabe kannst du erst beantragen, wenn du einen VServer hast.',
      forced: 'Wir haben Port 25 für deine VServer gesperrt. Eine Freigabe kannst du hier nicht beantragen, melde dich bei unserem Support.',
      cooldown: 'Nach einer Ablehnung kannst du 14 Tage lang keine neue Anfrage stellen.',
      rateLimited: 'Du hast heute schon mehrere Anfragen gestellt. Versuch es morgen noch einmal.'
    }
  },
  network: {
    ipv4Title: 'IPv4',
    ipv6Title: 'IPv6 /112',
    ptrTitle: 'PTR-Record',
    ptrLabel: 'Reverse DNS',
    ptrSave: 'PTR speichern',
    ptrSaved: 'PTR-Record aktualisiert',
    ptrUnavailable: 'Den PTR-Record setzt der Support für dich. Schreib uns den Namen, auf den deine Adresse auflösen soll.',
    firewallTitle: 'Firewall-Regeln',
    firewallAdd: 'Regel hinzufügen',
    firewallEmpty: 'Noch keine Firewall-Regeln definiert.',
    firewallDeleteConfirm: 'Firewall-Regel #{position} löschen?',
    table: {
      position: '#',
      direction: 'Richtung',
      action: 'Aktion',
      protocol: 'Protokoll',
      source: 'Quelle',
      dest: 'Ziel',
      ports: 'Ports',
      comment: 'Kommentar',
      enabled: 'Aktiv'
    }
  },
  snapshots: {
    title: 'Snapshots',
    subtitle: 'Stelle deinen Server jederzeit auf einen früheren Stand zurück.',
    create: 'Snapshot erstellen',
    name: 'Name',
    description: 'Beschreibung',
    size: 'Größe',
    status: 'Status',
    createdAt: 'Erstellt am',
    rollback: 'Auf diesen Stand zurücksetzen',
    delete: 'Löschen',
    autoBadge: 'Automatisch',
    empty: 'Noch keine Snapshots vorhanden.',
    emptyHint: 'Erstelle einen Snapshot, um jederzeit auf diesen Stand zurücksetzen zu können.',
    confirmRollback: 'Snapshot {name} wirklich wiederherstellen? Alle Änderungen seit dem Snapshot gehen verloren.',
    confirmDelete: 'Snapshot {name} löschen?',
    usage: '{used} von {limit} belegt',
    limitHint: 'Dein Tarif enthält {limit} Snapshots. Lösch einen, um einen neuen anzulegen.',
    createSuccess: 'Snapshot {name} wurde erstellt.',
    rollbackSuccess: 'Snapshot wiederhergestellt.',
    deleteSuccess: 'Snapshot gelöscht.'
  },
  graphs: {
    title: 'Auslastung',
    cpu: 'CPU',
    memory: 'Arbeitsspeicher',
    disk: 'Festplatten-I/O',
    network: 'Netzwerk',
    timeframe: {
      hour: 'Stunde',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat'
    },
    noData: 'Keine Messwerte verfügbar.'
  },
  settings: {
    title: 'Einstellungen',
    hostnameTitle: 'Hostname',
    hostnameLabel: 'Neuer Hostname',
    hostnameSave: 'Hostname speichern',
    hostnameSaved: 'Hostname wurde aktualisiert.',
    hostnameInvalid: 'Nur Buchstaben, Ziffern, Bindestriche und Punkte, höchstens 63 Zeichen.',
    reinstallTitle: 'Neu installieren',
    reinstallDescription: 'Setzt den VServer auf eine frische Vorlage zurück. Alle Daten gehen verloren.',
    reinstallAction: 'OS neu installieren',
    resizeTitle: 'Tarif ändern',
    resizeDescription: 'Wechsle auf einen größeren oder kleineren Tarif (Neustart erforderlich).',
    resizeAction: 'Tarif ändern',
    resetPasswordTitle: 'Root-Passwort zurücksetzen',
    resetPasswordDescription: 'Setzt ein neues root-Passwort über den Gast-Agent. Das Passwort wird einmalig angezeigt.',
    resetPasswordAction: 'Passwort zurücksetzen',
    sshKeyTitle: 'SSH-Schlüssel einspielen',
    sshKeyDescription: 'Spielt einen deiner gespeicherten SSH-Schlüssel über den Gast-Agent auf den laufenden Server.',
    sshKeyAction: 'SSH-Schlüssel einspielen',
    rescueTitle: 'Rettungssystem',
    rescueDescription: 'Bootet den VServer in eine Live-Umgebung. Bootreihenfolge wird beim nächsten Start zurückgesetzt.',
    rescueAction: 'Rescue Mode starten',
    exitRescueAction: 'Rescue Mode beenden',
    deleteTitle: 'VServer löschen',
    deleteDescription: 'Löscht den VServer endgültig. Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteAction: 'VServer löschen'
  },
  dialogs: {
    reinstall: {
      title: 'Betriebssystem neu installieren',
      message: 'Alle Daten auf dem VServer werden gelöscht. Wirklich fortfahren?',
      templateLabel: 'OS-Vorlage',
      sshKeysLabel: 'SSH-Public-Keys (eine pro Zeile, optional)',
      confirm: 'Neu installieren',
      cancel: 'Abbrechen',
      typeHostnameHint: 'Tippe {hostname} zur Bestätigung',
      invalidKey: 'Mindestens ein SSH-Key ist ungültig. Der Server wurde nicht verändert.'
    },
    resize: {
      title: 'Tarif ändern',
      message: 'Wähle einen neuen Tarif für deinen VServer.',
      diskGrowOnly: 'Hinweis: Die Festplatte kann nur vergrößert werden, nicht verkleinert.',
      resizeDiskLabel: 'Festplatte auf neue Tarifgröße erweitern',
      keepDiskHint: 'Die aktuelle Festplattengröße bleibt erhalten. Das ist nötig, wenn du später eventuell auf einen kleineren Tarif wechseln möchtest – eine vergrößerte Festplatte lässt sich nicht mehr verkleinern.',
      skipSnapshotLabel: 'Sicherheits-Snapshot überspringen',
      safetySnapshotHint: 'Vor der Änderung wird automatisch ein Snapshot erstellt, damit du bei Problemen zurücksetzen kannst.',
      skipSnapshotHint: 'Es wird kein automatischer Snapshot erstellt. Ein Zurücksetzen ist dann nicht möglich.',
      confirm: 'Tarif anwenden',
      cancel: 'Abbrechen',
      // A plan paid for 3, 6 or 12 months: the server is resized before the
      // payment arrives (vServer agreement § 7.5).
      termCharge: 'Für die Zeit von heute bis zum {date} berechnen wir dir jetzt den Unterschied von {amount} über deine hinterlegte Zahlungsmethode. Wir stellen den Server sofort um, auch wenn die Zahlung, etwa per SEPA-Lastschrift, noch nicht eingegangen ist; der neue Tarif gilt ab Eingang der Zahlung. Schlägt sie fehl, bleibt der Server umgestellt, und du kannst den Unterschied innerhalb von 14 Tagen bezahlen oder den Server in den bisherigen Tarif zurückstellen. Tust du keines von beiden, endet der Vertrag mit Ablauf dieser Frist.',
      termPending: 'Deine SEPA-Lastschrift wird noch eingezogen. Wir stellen deinen Server schon jetzt um; der neue Tarif gilt ab Eingang der Zahlung. Schlägt der Einzug fehl, bleibt der Server umgestellt, und du kannst den Unterschied innerhalb von 14 Tagen bezahlen oder den Server in den bisherigen Tarif zurückstellen.',
      // Paying a difference already due: the server runs on that tier, and
      // the first due date stands.
      payCharge: 'Dein Server läuft bereits in diesem Tarif und wird nicht umgestellt. Für die Zeit von heute bis zum {date} berechnen wir dir jetzt den Unterschied von {amount} über deine hinterlegte Zahlungsmethode; mit Eingang der Zahlung gilt der neue Tarif. Schlägt die Zahlung fehl, endet der Vertrag am {deadline} mit Ablauf der Zahlungsfrist oder, wenn das später ist, mit dem Fehlschlagen der Zahlung.',
      payPending: 'Deine SEPA-Lastschrift wird noch eingezogen. Dein Server läuft weiter in diesem Tarif, der ab Eingang der Zahlung gilt. Schlägt der Einzug fehl, endet der Vertrag am {deadline} mit Ablauf der Zahlungsfrist oder, wenn das später ist, mit dem Fehlschlagen des Einzugs.',
      afterPaymentNote: 'Weil in den letzten zwölf Monaten die Zahlung eines Tarifwechsels für einen Vertrag deines Kundenkontos fehlgeschlagen ist, stellen wir den Server erst um, wenn die Zahlung eingegangen ist.',
      resizeBack: 'Wir stellen den Server in den Tarif zurück, für den du bezahlt hast. Damit ist nichts mehr offen, und es wird nichts berechnet.'
    },
    delete: {
      title: 'VServer löschen',
      message: 'Diese Aktion löscht den VServer endgültig inklusive aller Snapshots und IP-Adressen.',
      typeHostname: 'Gib zur Bestätigung {hostname} ein.',
      confirm: 'Endgültig löschen',
      cancel: 'Abbrechen'
    },
    snapshot: {
      title: 'Snapshot erstellen',
      nameLabel: 'Name',
      descriptionLabel: 'Beschreibung (optional)',
      vmstateLabel: 'Arbeitsspeicher mitsichern (VMState)',
      confirm: 'Erstellen',
      cancel: 'Abbrechen'
    },
    firewall: {
      titleCreate: 'Firewall-Regel hinzufügen',
      titleEdit: 'Firewall-Regel bearbeiten',
      directionLabel: 'Richtung',
      actionLabel: 'Aktion',
      protocolLabel: 'Protokoll',
      sportLabel: 'Quell-Port',
      dportLabel: 'Ziel-Port',
      sourceLabel: 'Quelle (IP/CIDR)',
      destLabel: 'Ziel (IP/CIDR)',
      commentLabel: 'Kommentar',
      enableLabel: 'Regel aktiv',
      save: 'Speichern',
      cancel: 'Abbrechen',
      invalidRule: 'Die Regel wurde abgelehnt. Prüfe die Felder und versuche es erneut.',
      limitReached: 'Dieser Server hat bereits {limit} Firewall-Regeln, mehr sind nicht möglich. Lösche eine Regel, bevor du eine neue hinzufügst.',
      busy: 'Gerade läuft eine andere Firewall-Änderung an diesem Server. Versuche es gleich noch einmal.',
      rateLimited: 'Zu viele Firewall-Änderungen in kurzer Zeit. Warte eine Minute und versuche es dann erneut.',
      changed: 'Die Firewall-Regeln haben sich geändert, seit diese Liste geladen wurde. Jetzt siehst du die aktuellen Regeln, prüfe sie und versuche es erneut.',
      invalidStored: 'Die Firewall lässt sich nicht einschalten, solange die Regeln {positions} nicht angewendet werden können. Ändere oder lösche sie und versuche es dann erneut.',
      notReady: 'Firewall-Regeln kannst du nur ändern, während der Server läuft oder gestoppt ist, nicht während er eingerichtet, neu installiert oder auf einen anderen Tarif umgestellt wird.',
      ruleExpansion: 'Eine Regel darf höchstens {limit} Paare aus Quell- und Zieladresse treffen (die Zahl der Quellen mal die Zahl der Ziele).',
      totalExpansion: 'Die Regeln dieses Servers dürfen zusammen höchstens {limit} Paare aus Quell- und Zieladresse treffen. Kürze zuerst die Adresslisten einiger Regeln.'
    },
    rescue: {
      title: 'Rescue-Modus starten',
      message: 'Der VServer wird neu gestartet und bootet in das Rettungssystem. Öffne danach die Konsole, um es zu benutzen.',
      confirm: 'Rescue starten',
      cancel: 'Abbrechen'
    },
    exitRescue: {
      title: 'Rescue-Modus beenden',
      message: 'Der VServer wird neu gestartet und bootet wieder von der normalen Festplatte.',
      confirm: 'Rescue beenden',
      cancel: 'Abbrechen',
      success: 'Rescue-Modus wird beendet.'
    },
    resetPassword: {
      title: 'Root-Passwort zurücksetzen',
      message: 'Ein neues root-Passwort wird über den Gast-Agent gesetzt und einmalig angezeigt. Der Server muss dafür laufen.',
      confirm: 'Passwort zurücksetzen',
      cancel: 'Abbrechen',
      close: 'Schließen',
      password: 'Neues Root-Passwort',
      shownOnce: 'Notiere dir das Passwort jetzt – es wird nur einmal angezeigt.'
    },
    sshKey: {
      title: 'SSH-Schlüssel einspielen',
      message: 'Spiele einen deiner gespeicherten SSH-Schlüssel über den Gast-Agent auf den laufenden Server.',
      keyLabel: 'Gespeicherter SSH-Schlüssel',
      replaceLabel: 'Alle vorhandenen Schlüssel ersetzen',
      appendHint: 'Der Schlüssel wird zu den vorhandenen authorized_keys hinzugefügt.',
      replaceHint: 'Alle bestehenden authorized_keys werden durch diesen Schlüssel ersetzt.',
      noKeys: 'Du hast noch keine SSH-Schlüssel gespeichert.',
      manageKeys: 'SSH-Schlüssel verwalten',
      confirm: 'Einspielen',
      cancel: 'Abbrechen',
      success: 'SSH-Schlüssel wurde eingespielt.'
    }
  },
  shop: {
    productMissing: 'Produkt noch nicht im Katalog verfügbar.',
    sshKeyLabel: 'SSH-Schlüssel',
    sshKeyHint: 'Wird beim ersten Start als root-Zugang hinterlegt. Optional — ohne Schlüssel fügst du den Zugang nach dem Kauf im Dashboard hinzu.',
    sshKeyEmpty: 'Du hast noch keine SSH-Schlüssel gespeichert. Kein Problem — du kannst den Zugang auch nach dem Kauf einrichten.',
    sshKeyAdd: 'SSH-Schlüssel hinzufügen',
    sshKeyAddNew: 'Neuen hinzufügen',
    modePredefined: 'Vordefiniert',
    modeCustom: 'Eigene Konfiguration',
    soldOut: 'Ausverkauft',
    specs: {
      vcpu: '{n} vCPU',
      ram: '{n} GB RAM',
      disk: '{n} GB NVMe',
      snapshots: '{n} Snapshots',
      ipv4: '1× IPv4 + IPv6 /112'
    },
    customShape: {
      title: 'Eigene Konfiguration',
      subtitle: 'Stelle vCPU, RAM und Speicher frei zusammen.',
      vcpu: 'vCPU',
      ram: 'RAM',
      disk: 'Speicher',
      priceNote: 'Monatlich: erster Monat bei Bestellung, danach stündlich, höchstens zum Monatspreis. Längere Zeiträume zahlst du im Voraus.',
      compare: 'Nächster Tarif {name}: {price}',
      added: 'Eigene Konfiguration zum Warenkorb hinzugefügt.'
    }
  },
  errors: {
    serviceEnded: 'Das Abonnement dieses Servers ist beendet. Du kannst ihn nicht mehr starten oder ändern.',
    locked: 'Dieser Server ist von uns gesperrt. Du kannst ihn nicht starten oder ändern, nur löschen.',
    snapshotBusy: 'Gerade läuft eine andere Snapshot-Aktion an diesem Server. Versuch es noch einmal, wenn sie fertig ist.',
    busy: 'Die Konfiguration des Servers wird gerade geändert. Versuch es in einer Minute noch einmal.',
    identityUnprovenDelete: 'Die Abrechnung für diesen Server ist beendet. Die virtuelle Maschine löschen wir, sobald unser Support bestätigt hat, dass sie zu diesem Server gehört.',
    identityUnproven: 'Wir konnten nicht bestätigen, dass die virtuelle Maschine hinter diesem Server zu ihm gehört, deshalb haben wir die Aktion zu deinem Schutz nicht ausgeführt. Bitte wende dich an den Support.',
    fetchFailed: 'VServer konnten nicht geladen werden.',
    actionFailed: 'Aktion fehlgeschlagen.',
    consoleUnavailable: 'Konsole nicht verfügbar.',
    statsUnavailable: 'Statistiken nicht verfügbar.'
  },
  admin: {
    title: 'Alle VServer',
    subtitle: 'Verwalte VServer kontoübergreifend',
    searchPlaceholder: 'Hostname oder IP suchen...',
    statusFilter: 'Status',
    statusAll: 'Alle Status',
    table: {
      hostname: 'Hostname',
      account: 'Account',
      status: 'Status',
      ipv4: 'IPv4',
      plan: 'Tarif',
      node: 'Node',
      createdAt: 'Erstellt'
    },
    empty: {
      title: 'Keine VServer gefunden',
      description: 'Mit den aktuellen Filtern wurden keine VServer gefunden.'
    },
    detail: {
      title: 'VServer-Details',
      forceProvision: 'Provisionierung erzwingen',
      forceDeprovision: 'Deprovisionierung erzwingen',
      backToList: 'Zurück zur Liste',
      proxmoxInfo: 'Proxmox-Informationen',
      proxmoxVmid: 'VMID',
      proxmoxNode: 'Node',
      errorLabel: 'Letzter Fehler',
      lockTitle: 'Sperrung',
      lockDescription: 'Eine Sperrung stoppt den Server und verhindert Start, Neuinstallation, Rescue, Snapshot-Wiederherstellung, Konsole und Firewall-Änderungen. Festplatte, IPs und Abrechnung bleiben, der Kunde kann den Server weiterhin löschen.',
      lockAction: 'Server sperren',
      unlockAction: 'Sperrung aufheben',
      lockedSince: 'Gesperrt seit {date}. Nach dem Aufheben bleibt der Server gestoppt.',
      lockDialogTitle: 'Server sperren',
      lockDialogDescription: 'Server {hostname} wird gestoppt und gesperrt. Die Begründung sieht der Kunde im Dashboard und in der E-Mail.',
      lockNoteLabel: 'Begründung für den Kunden',
      unlockConfirm: 'Sperrung aufheben? Der Server bleibt gestoppt, bis der Kunde ihn startet.',
      lockSuccess: 'Server gesperrt und gestoppt.',
      unlockSuccess: 'Sperrung aufgehoben.'
    },
    smtp: {
      title: 'Port 25',
      subtitle: 'Anfragen auf vorzeitige Freigabe und Sperren von Port 25',
      loadError: 'Anfragen konnten nicht geladen werden',
      actionError: 'Aktion fehlgeschlagen',
      empty: 'Keine Konten in dieser Ansicht.',
      forced: 'Von uns gesperrt',
      grandfathered: 'Bestandskunde',
      days: '{n} Tage',
      approveBlocked: 'Freigeben geht erst, wenn die Sperre durch uns aufgehoben ist.',
      truncated: 'Es werden nur die ersten {n} Konten angezeigt, die ältesten Anfragen zuerst.',
      decisionNote: 'Begründung der Entscheidung: {note}',
      forcedReason: 'Grund der Sperre: {reason}',
      refusals: {
        grandfathered: 'Bestandskunden fallen nicht unter die Port-25-Regel. Sperre stattdessen den VServer.',
        requestPending: 'Es liegt eine offene Anfrage vor. Entscheide sie zuerst, dann kannst du sperren.',
        noPendingRequest: 'Es gibt keine offene Anfrage mehr. Die Liste ist neu geladen.',
        forced: 'Freigeben geht erst, wenn die Sperre durch uns aufgehoben ist.',
        notBlocked: 'Port 25 ist für dieses Konto schon offen. Die Liste ist neu geladen.'
      },
      tagSync: {
        deferred: 'Gespeichert. Die Server übernehmen den neuen Stand mit dem nächsten Abgleich, spätestens in 10 Minuten.',
        failed: 'Gespeichert, aber die Server konnten nicht aktualisiert werden. Der nächste Abgleich in spätestens 10 Minuten versucht es erneut.'
      },
      confirmFor: 'Konto: {email}',
      noteLabel: 'Begründung für den Kunden',
      notePlaceholder: 'Die Begründung geht per E-Mail an den Kunden.',
      filter: {
        label: 'Ansicht',
        pending: 'Offene Anfragen',
        forced: 'Von uns gesperrt',
        approved: 'Freigegeben',
        denied: 'Abgelehnt',
        none: 'Ohne Anfrage',
        all: 'Alle'
      },
      statusLabel: {
        none: 'Keine Anfrage',
        pending: 'Offen',
        approved: 'Freigegeben',
        denied: 'Abgelehnt'
      },
      signals: {
        age: 'Kontoalter',
        vservers: 'VServer',
        opensAt: 'Freigabe ab',
        verified: 'E-Mail bestätigt',
        payment: 'Zahlungsmittel',
        requested: 'Angefragt'
      },
      actions: {
        approve: 'Freigeben',
        approveWithoutRequest: 'Ohne Anfrage freigeben',
        deny: 'Ablehnen',
        block: 'Sperren',
        unblock: 'Sperre aufheben',
        denyTitle: 'Anfrage ablehnen',
        blockTitle: 'Port 25 sperren',
        approveSuccess: 'Port 25 freigegeben',
        denySuccess: 'Anfrage abgelehnt',
        blockSuccess: 'Port 25 gesperrt',
        unblockSuccess: 'Sperre aufgehoben'
      }
    },
    ipPool: {
      title: 'IP-Pool',
      subtitle: 'Verwalte verfügbare IP-Adressen',
      available: 'Verfügbar',
      allocated: 'Belegt',
      reserved: 'Reserviert',
      lowWarning: 'Wenige IPs verfügbar ({count}). Bitte über Hetzner Robot weitere IPs einkaufen.',
      addTitle: 'IP-Adresse registrieren',
      addressLabel: 'IP-Adresse',
      subnetLabel: 'Subnetz (CIDR, optional)',
      gatewayLabel: 'Gateway (optional)',
      versionLabel: 'IP-Version',
      addAction: 'IP hinzufügen',
      addSuccess: 'IP wurde dem Pool hinzugefügt.',
      table: {
        address: 'Adresse',
        version: 'Version',
        status: 'Status',
        allocatedTo: 'Zugewiesen an',
        allocatedAt: 'Zugewiesen am'
      }
    },
    import: {
      title: 'VM importieren',
      subtitle: 'Bestehende Proxmox-VM als verwalteten VServer übernehmen',
      accountTitle: 'Kunde',
      accountMode: 'Kontomodus',
      existingAccount: 'Bestehendes Konto',
      newAccount: 'Neues Konto anlegen',
      selectAccount: 'Konto auswählen',
      email: 'E-Mail',
      name: 'Vorname',
      surname: 'Nachname',
      org: 'Organisation',
      line1: 'Adresse',
      city: 'Stadt',
      postcode: 'PLZ',
      country: 'Land (ISO)',
      state: 'Bundesland',
      phone: 'Telefon',
      phoneCode: 'Vorwahl',
      stripeCustomer: 'Bestehende Stripe-Customer-ID (optional)',
      cancelSub: 'Altes Stripe-Abo kündigen (ID, optional)',
      cancelSubHint:
        'Trage die ID eines bestehenden manuellen Stripe-Abos ein, um Doppelberechnung zu vermeiden.',
      vmTitle: 'VM & Preis',
      node: 'Proxmox-Node',
      nodeManualHint:
        'Node-Liste nicht verfügbar. Trage den Cluster-Node-Namen ein (z. B. pve1), nicht die API-Adresse.',
      vmid: 'VMID',
      ipv4: 'IPv4-Adresse',
      ipv6Block: 'IPv6-Block /112 (optional)',
      ipv6BlockHint:
        'Der geroutete /112, z. B. 2a01:4f8:191:8310::2:0/112. Ohne ihn blockiert der Quellfilter die IPv6 des Servers.',
      subnet: 'Subnetz (optional)',
      gateway: 'Gateway (optional)',
      hostname: 'Hostname (optional)',
      template: 'Template-Slug (optional)',
      priceEuro: 'Monatspreis brutto (€)',
      billingFreq: 'Abrechnungszyklus',
      freqMonthly: 'Monatlich',
      freqAnnually: 'Jährlich',
      priceHint: 'Exakter Bruttopreis inkl. MwSt. Wird zum Monatsersten in Rechnung gestellt.',
      vcpu: 'vCPU (optional)',
      memoryMb: 'RAM MB (optional)',
      diskGb: 'Disk GB (optional)',
      specsHint: 'Leer lassen, um die Specs aus der laufenden VM zu übernehmen.',
      submit: 'VM importieren',
      success: 'VServer importiert.',
      alreadyImported: 'Bereits importiert.',
      invalidForm: 'Bitte fülle alle Pflichtfelder aus.',
      resultTitle: 'Ergebnis',
      rVserver: 'VServer',
      rSubscription: 'Abo',
      rAccount: 'Konto',
      rStripeSub: 'Stripe-Abo',
      rTrialEnd: 'Abrechnung ab',
      createdAccountNote: 'Ein neues Konto wurde angelegt. Eine Willkommens-E-Mail wurde versandt.',
      canceledNote: 'Altes Stripe-Abo {id} wurde gekündigt.',
      otherSubsWarning:
        'Achtung: Der Kunde hat weitere aktive Stripe-Abos. Bitte manuelle Abrechnung prüfen:'
    },
    templates: {
      title: 'Templates',
      subtitle: 'OS-Templates für die VServer-Bereitstellung verwalten',
      prereqHint:
        'Das Template muss als Cloud-Init-Template-VM in Proxmox existieren — hier nur die VMID + Node registrieren. (Für den Import bestehender VMs nicht nötig.)',
      addTitle: 'Template registrieren',
      editTitle: 'Template bearbeiten',
      cancelEdit: 'Abbrechen',
      slug: 'Slug',
      name: 'Name',
      osFamily: 'OS-Familie',
      osName: 'OS-Name',
      osVersion: 'OS-Version',
      vmid: 'Proxmox-Template-VMID',
      node: 'Proxmox-Node',
      minDisk: 'Min. Disk (GB)',
      sortOrder: 'Sortierung',
      active: 'Aktiv',
      add: 'Template hinzufügen',
      save: 'Speichern',
      edit: 'Bearbeiten',
      created: 'Template wurde registriert.',
      updated: 'Template wurde aktualisiert.',
      empty: 'Noch keine Templates registriert.',
      activeYes: 'Aktiv',
      activeNo: 'Inaktiv',
      table: {
        name: 'Name',
        slug: 'Slug',
        os: 'OS',
        vmid: 'VMID',
        node: 'Node',
        active: 'Status'
      }
    }
  }
} as const
